import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter
} from "../components/ui/dialog";
import { Textarea } from "../components/ui/textarea";
import { CalendarCheck, Users } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

const BookingDialog = ({ restaurant, trigger }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: "",
    date: new Date(Date.now() + 86400000).toISOString().slice(0, 10),
    time: "19:00",
    guests: 2,
    notes: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!user) {
      toast.error("Login dulu untuk booking");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/bookings", {
        ...form,
        restaurant_id: restaurant.id,
        guests: parseInt(form.guests),
      });
      toast.success("Booking dikirim! Owner akan konfirmasi via email/notifikasi.");
      setOpen(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Gagal booking");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button className="w-full rounded-full bg-primary hover:bg-primary/90" data-testid="book-table-btn">
            <CalendarCheck className="w-4 h-4 mr-2" /> Book Meja
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-md" data-testid="booking-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Book Meja di {restaurant.name}</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label>Nama *</Label>
            <Input required data-testid="booking-name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <Label>Nomor HP / WhatsApp *</Label>
            <Input required data-testid="booking-phone" placeholder="08xxx" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
          </div>
          <div className="grid grid-cols-3 gap-2">
            <div>
              <Label>Tanggal *</Label>
              <Input required type="date" data-testid="booking-date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} />
            </div>
            <div>
              <Label>Jam *</Label>
              <Input required type="time" data-testid="booking-time" value={form.time} onChange={e => setForm({ ...form, time: e.target.value })} />
            </div>
            <div>
              <Label>Tamu *</Label>
              <Input required type="number" min={1} max={20} data-testid="booking-guests" value={form.guests} onChange={e => setForm({ ...form, guests: e.target.value })} />
            </div>
          </div>
          <div>
            <Label>Catatan (opsional)</Label>
            <Textarea data-testid="booking-notes" placeholder="Permintaan khusus..." value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={submitting} className="w-full rounded-full" data-testid="booking-submit">
              {submitting ? "Mengirim..." : "Kirim Booking"}
            </Button>
          </DialogFooter>
          <p className="text-xs text-muted-foreground text-center">Booking akan dikonfirmasi manual oleh owner restoran.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default BookingDialog;
